import { render, staticRenderFns } from "./bianminPhone.vue?vue&type=template&id=1c07f49c&scoped=true&"
import script from "./bianminPhone.vue?vue&type=script&lang=js&"
export * from "./bianminPhone.vue?vue&type=script&lang=js&"
import style0 from "./bianminPhone.vue?vue&type=style&index=0&id=1c07f49c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c07f49c",
  null
  
)

export default component.exports